<template>
  <div class="mydialog">
    <div class="page_title">药品审核</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo noneline"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="1" class="title" style="font-size: 16px"
                >待审核</el-menu-item
              >
              <el-menu-item
                index="2,3"
                class="title space"
                style="font-size: 16px"
                >已审核</el-menu-item
              >
            </el-menu>
          </div>
          <div class="box">
            <div class="searchbox flex between" style="text-align: left">
              <span style="margin-right: 8px">药房名称</span>
              <!-- <el-input
                v-model="hospital_name"
                style="width: 120px; margin: 0 20px 0 10px"
                @change="search"
                clearable
              ></el-input> -->
              <myInputSerch
                v-model="hospital_name"
                @update="search"
                style="margin-right: 10px"
              ></myInputSerch>
              <span>药品名称</span>
              <el-input
                v-model="goods_name"
                style="width: 120px; margin: 0 20px 0 10px"
                @change="search"
                clearable
              ></el-input>
              <span>剂型</span>
              <el-select
                v-model="dosage_form"
                placeholder="请选择"
                style="width: 120px; margin: 0 20px 0 10px"
                @change="search"
                clearable
              >
                <el-option
                  v-for="item in dosage_form_list"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
              <span>提交时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 264px; margin: 0 12px"
                @change="search"
              ></el-date-picker>

              <el-button
                type="info"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-right: 15px;
                "
                @click="search"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="examineAll"
                style="width: 120px; margin-left: auto"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('96') : false
                "
                >批量审核</el-button
              >
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection"></el-table-column>

                <el-table-column
                  label="药房名称"
                  prop="hospital_name"
                ></el-table-column>
                <el-table-column
                  label="药品名称"
                  prop="goods_name"
                ></el-table-column>

                <el-table-column label="剂型">
                  <template slot-scope="scope">
                    <div>
                      <span>{{ scope.row.drug_type_name }}</span>
                    </div>
                    <div>当量:{{ scope.row.conversion }}g</div>
                  </template>
                </el-table-column>

                <el-table-column label="规格">
                  <template slot-scope="scope">
                    <div>{{ scope.row.dosage_unit_name }}</div>
                    <div v-if="scope.row.dosage_unit != 2">
                      {{ scope.row.dosage_num }}g/{{
                        scope.row.dosage_unit_name
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="成本价(元）"
                  prop="cost_price"
                ></el-table-column>
                <el-table-column
                  label="销售价(元）"
                  prop="price"
                ></el-table-column>

                <el-table-column label="提交时间" prop="create_time">
                  <template slot-scope="scope">
                    <div>{{ scope.row.create_date }}</div>
                    <div>{{ scope.row.create_time }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="修改内容" prop="edit_content">
                  <template slot-scope="scope">
                    <div v-for="(item,index) in scope.row.edit_content" :key="index">
                    <span>{{item.name}}修改前:&nbsp;&nbsp;</span>
                    <span>{{item.value}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="审核状态" v-if="active == '2,3'">
                  <template slot-scope="scope">
                    <span v-if="scope.row.reviewed_status == 2">通过</span>
                    <span
                      style="color: #f24b2f"
                      v-if="scope.row.reviewed_status == 3"
                      >不通过</span
                    >
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.goods_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('97')
                          : false
                      "
                      >查看详情</el-button
                    >
                    <el-button
                      type="text"
                      v-if="scope.row.reviewed_status == 1"
                      @click="examine(scope.row.goods_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('96')
                          : false
                      "
                      >审核</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin: 20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myInputSerch from "@/components/myInputSerch";
import hospital from "../../../api/hospital";
import platform from "../../../api/platform";
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      Selection: [],
      dosage_form_list: [],
      activeIndex: "1",
      active: 1,
      hospital_name: "",
      goods_name: "",
      dosage_form: "",
      date: [],
    };
  },
  components: {
    myInputSerch,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取审核列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name,
        goods_name: this.goods_name,
        dosage_form: this.dosage_form,
        auth_status: this.active,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      hospital.getGoodsAuthList(data).then((res) => {
        if (res.code == 0) {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list.map((item) => {
            item.create_date = platform.timestampToDate(item.update_time);
            item.create_time = platform.timestampTohour(item.update_time);
            item.edit_content = JSON.parse(item.edit_content);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.dosage_form_list = res.data.list;
        });
    },
    handleSelect(key) {
      // this.hospital_name = '';
      this.goods_name = "";
      this.dosage_form = "";
      this.active = key;
      this.currentPage = 1;
      this.pagesize = 10;
      this.date = [];
      this.getList();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChange(val) {
      this.Selection = val;
    },

    //药房详情
    toDetail(goods_id) {
      this.$router.push({ path: "drugsdetail", query: { goods_id } });
    },
    //审核
    examine(goods_id) {
      this.$confirm("是否审核通过？", "审核", {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
      })
        .then(() => {
          let auth_status = 2;
          hospital.auditGoods({ goods_id, auth_status }).then((res) => {
            if (res.code == 0) {
              this.$message.success("该药品审核通过!");
            }
            this.getList();
          });
        })
        .catch((action) => {
          if (action === "cancel") {
            let auth_status = 3;
            hospital.auditGoods({ goods_id, auth_status }).then((res) => {
              if (res.code == 0) {
                this.$message.error("该药品审核未通过!");
              }
              this.getList();
            });
          }
        });
    },
    //批量审核
    examineAll() {
      if (!this.Selection.length) {
        this.$message.error("请勾选'审核中'的记录");
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.goods_id;
      });
      let goods_id = selectId.toString();
      this.examine(goods_id);
    },
  },
  created() {
    this.getList();
    this.getDrugTypeList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>
